import { authorizeGetRequest, authorizePostRequest } from "api";
import {
  ILotteryInfo,
  ILotteryStatus,
  ILotteryWinner,
  ILotteryStatistics
} from "models";

// Get lottery information for a specific trip
export const getTripLotteryApi = (tripId: string) => {
  return authorizeGetRequest<ILotteryInfo>(
    `trips/lottery/${tripId}`
  );
};

// Perform lottery rollout (select winners)
export const performLotteryRolloutApi = (data?: { prize_amount?: number }) => {
  return authorizePostRequest<{
    message: string;
    winners_selected: number;
    winners: ILotteryWinner[];
  }>(
    `trips/lottery/rollout`,
    data
  );
};

// Get lottery status (is rollout day, etc)
export const getLotteryStatusApi = () => {
  return authorizeGetRequest<ILotteryStatus>(
    `trips/lottery/status`
  );
};

// Get detailed lottery statistics
export const getLotteryStatisticsApi = () => {
  return authorizeGetRequest<ILotteryStatistics>(
    `trips/lottery/statistics`
  );
};

// Select a specific winner for lottery (admin action)
export const selectLotteryWinnerApi = (lotteryNumber: string, prizeAmount: number) => {
  return authorizePostRequest<{
    message: string;
    winner: ILotteryWinner;
  }>(
    `trips/lottery/select-winner`,
    { lottery_number: lotteryNumber, prize_amount: prizeAmount }
  );
};
// Search for lottery trip details by lottery number
export const searchLotteryNumberApi = (lotteryNumber: string) => {
  return authorizeGetRequest<ILotteryInfo>(
    `trips/lottery/search?lottery_number=${lotteryNumber}`
  );
};

// Select multiple winners for lottery (admin action, no notifications)
export const selectWinnersApi = (numWinners: number = 3) => {
  return authorizePostRequest<{
    success: boolean;
    winners_selected: number;
    winner_lottery_numbers: string[];
  }>(
    `trips/lottery/select-winners`,
    { num_winners: numWinners }
  );
};

